module.exports = __webpack_public_path__ + "static/customer-testimonial-bg-6-b537dd137f847bdf3b218c618b331081.png";